import configuratorChoices from '~/data/configuratorChoices/bagConfiguratorChoices';
import { ProductViewConfigurator } from '~/types/configurator';

export default {
    controls: [
        {
            key: 'color',
            keyLabel: 'color',
            choices: [
                configuratorChoices.colors.black,
                configuratorChoices.colors.white,
                configuratorChoices.colors.brown,
                configuratorChoices.colors.customWithPattern,
            ],
            hideOnProductPage: true,
        },
        {
            key: 'material',
            keyLabel: 'material',
            choices: [
                configuratorChoices.materials.standard,
                configuratorChoices.materials.compostable,
                configuratorChoices.materials.recyclable,
            ],
            hideOnProductPage: true,
        },
        {
            key: 'finish',
            keyLabel: 'finish',
            choices: [
                configuratorChoices.finishes.matte,
                configuratorChoices.finishes.gloss,
            ],
            hideOnProductPage: true,
        },
    ],
} as ProductViewConfigurator;
